module.exports = __webpack_public_path__ + "img/icon_instagram.8a051c33772c6ffabe813af16f99f627.svg";